export default {
      id: "manufacturer-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "sprite.svg#manufacturer",
      toString: function () {
        return this.url;
      }
    }